import {chatRequest} from './ChatService';

export const getThreadBusinessSource = (id, signal) => chatRequest(`/messages/${id}/business-source`, {signal});
export const getThreadBusinessLinks = (rootIds, signal) => chatRequest('/business-links/query', {method: 'POST', body: {root_ids: rootIds}, signal});

export async function readBusinessResponse(response) {
    const data = await response.json().catch(() => null);
    if (!response.ok) throw new Error(data?.detail || data?.message || data?.error?.message || `Request failed (${response.status})`);
    return data;
}

export async function saveThreadBusiness(kind, rootId, body) {
    // Legacy business auth imports the login UI. Keep it out of Chat's read path.
    const {getheaders} = await import('./authService');
    // Refresh authorization at save time; do not refresh the draft's image selection.
    const source = await getThreadBusinessSource(rootId);
    const response = await fetch(`/api/chat-business/${kind}`, {
        method: 'POST', headers: getheaders(), body: JSON.stringify({...body, source_token: source.source_token}),
    });
    return readBusinessResponse(response);
}
